import { Modal } from "antd";
import { CSSProperties, ReactNode } from "react";

type Props = {
  isOpen: boolean;
  hanldeCloseModal: () => void;
  children: ReactNode;
  title?: string | ReactNode;
  width?: number | string;
  centered?: boolean;
  isShowCloseIcon?: boolean;
  maxHeight?: number | string;
};

export default function CustomModal({
  isOpen,
  hanldeCloseModal,
  title,
  children,
  width,
  centered,
  isShowCloseIcon = true,
  maxHeight,
}: Props) {
  return (
    <Modal
      title={title}
      open={isOpen}
      onOk={hanldeCloseModal}
      onCancel={hanldeCloseModal}
      width={width}
      footer={null}
      centered={centered}
      closable={isShowCloseIcon}
    >
      <div
        style={{
          maxHeight,
          overflowY: maxHeight ? "auto" : undefined,
        }}
      >
        {children}
      </div>
    </Modal>
  );
}
